import React from "react";
import { Link } from "react-router-dom";
import "./styles/styles.css";

const ResultSearch = props => {
  const { identificador, code, images } = props.data;
  const imagen = JSON.parse(images[0]).url;
  return (
    <>
      <Link
        to={`/product/${identificador}`}
        className="text-decoration-none text-dark"
        onClick={() => (props.handle ? props.handle() : null)}
      >
        <center>
          <p className="text-search">
            <img src={imagen} alt={code} width="50px" className="img-search" />{" "}
            {code}
          </p>
        </center>
      </Link>
    </>
  );
};

export default ResultSearch;
